import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const SessionExpiredModal = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();

  useEffect(() => {
    // Prevent scrolling on the body when modal is open
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "unset";
    };
  }, []);

  const handleSignInAgain = () => {
    // Use AuthContext logout to properly update user state
    logout();
    
    // Dispatch event to close modal in App.js
    window.dispatchEvent(new CustomEvent("closeSessionExpiredModal"));
    
    // Redirect to login
    navigate("/login");
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.7)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 999999,
      }}
    >
      <div
        style={{
          backgroundColor: "white",
          padding: "40px",
          borderRadius: "8px",
          textAlign: "center",
          maxWidth: "400px",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
        }}
      >
        <h2
          style={{
            margin: "0 0 20px 0",
            color: "#333",
            fontSize: "24px",
          }}
        >
          Session Expired
        </h2>
        <p
          style={{
            margin: "0 0 30px 0",
            color: "#666",
            fontSize: "16px",
            lineHeight: "1.5",
          }}
        >
          Your session has expired. Please sign in again to continue.
        </p>
        <button
          onClick={handleSignInAgain}
          style={{
            backgroundColor: "#007bff",
            color: "white",
            border: "none",
            padding: "12px 32px",
            fontSize: "16px",
            borderRadius: "4px",
            cursor: "pointer",
            fontWeight: "500",
            transition: "background-color 0.2s",
          }}
          onMouseOver={(e) => {
            e.target.style.backgroundColor = "#0056b3";
          }}
          onMouseOut={(e) => {
            e.target.style.backgroundColor = "#007bff";
          }}
        >
          Sign In Again
        </button>
      </div>
    </div>
  );
};

export default SessionExpiredModal;
